// Create a new store instance.
import {createStore} from "vuex";
import {cabinet} from "@/store/modules/cabinet";
import {booking} from "@/store/modules/booking";
import {office} from "@/store/modules/office";
import {selector} from "@/store/modules/selector";


export const store = createStore({
    modules: {
        booking: booking,
        cabinet: cabinet,
        office: office,
        selector: selector
    },
    state: () => ({
        searchDataForm: {},
        memoryData: null,
        loading: false,
        x: 2, // масштаб
        vMode: 0, // режим отображения
        user: {},
        date: '',
        officeSelect: {},
        cpacitySelect: {},
        cabinetOptionsSelect: {},
        metroSelect: {},
        officeSelectDefault: -1, // id центра по умолчанию
        officeSelectCurrent: -1, // id центра текущего (для запоминания в куках и вывода)
        commission: 0
    }),
    mutations: {
        setOfficeCurrent(state, val){
            // console.log("setOfficeCurrent 2 " + val)
            state.officeSelectCurrent = val;
        },
        setX(state, val){
            state.x = val;
        },
        setVMode(state, val){
            state.vMode = val;
        },
        setSearchDataForm(state, val) {
            state.searchDataForm = val;
        },
        resetSearchDataForm(state) {
            state.searchDataForm = {};
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setUser(state, data) {
            state.user = data.user;
        },
        setDate(state, date) {
            state.date = date;
        },
        updateUserBalance(state, balance) {
            state.user.userBalance = balance;
        },
        setOfficeSelect(state, data) {
            state.officeSelect = data.officeSelect
        },
        setCabinetOptionsSelect(state, data) {
            state.cabinetOptionsSelect = data.cabinetOptionsSelect
        },
        setCpacitySelect(state, data) {
            state.cpacitySelect = data.cpacitySelect
        },
        setMetroSelect(state, data) {
            state.metroSelect = data.metroSelect
        },
        setCommission(state, data) {
            state.commission = data.commission
        },
        setMemoryData(state, data) {
            state.memoryData = data
        },
    },
    actions: {
        setMemoryData({commit}, val){
            commit('setMemoryData',val);
        },
        setOfficeCurrent({commit}, val){
            commit('setOfficeCurrent',val);
        },
        setX({commit}, val){
            commit('setX',val);
        },
        setVMode({commit}, val){
            commit('setVMode',val);
        },
        setData({dispatch, commit}, data) {
            dispatch('cabinet/setData', data);
            dispatch('office/setData', data);
            dispatch('booking/setData', data);
            commit('setUser', data);
            commit('setOfficeSelect', data);
            commit('setCpacitySelect', data);
            commit('setMetroSelect', data);
            commit('setCabinetOptionsSelect', data);
            commit('setCommission', data);
            commit('setOfficeCurrent', data.currentOfficeId);
            // console.log('data.currentOfficeId',data.currentOfficeId)
        },
        updateUserBalance({commit}, balance) {
            commit('updateUserBalance', balance);
        },

    }
})
